module.exports = __webpack_public_path__ + "static/media/beta-2.11537b6f.svg";